import { ColDef } from '@ag-grid-community/core';
import { formatDateTime } from '../../../../mbm/utils/bond-bid-utils';

export function getUserManagementColumns(): ColDef[] {
  return [
    {
      field: 'USER_NAME',
      headerName: 'UserID',
      width: 200,
      minWidth: 150,
    },
    {
      field: 'COUNTERPARTY_ID',
      headerName: 'Company Name',
      width: 350,
      minWidth: 250,
    },
    {
      field: 'LAST_LOGIN',
      headerName: 'Last Login',
      width: 200,
      minWidth: 150,
      valueFormatter: (params) => (params.value ? formatDateTime(params.value) : ''),
      filter: 'agDateColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        browserDatePicker: true,
        filterOptions: ['greaterThan', 'lessThan', 'inRange'],
      },
    },
    {
      field: 'ACCESS_TYPE',
      headerName: 'Access Type',
      width: 150,
      minWidth: 120,
    },
  ];
}

export function getUserLoginAuditColumns(): ColDef[] {
  return [
    {
      field: 'AUDIT_DATETIME',
      headerName: 'Timestamp',
      width: 200,
      minWidth: 150,
      valueGetter: (params) => {
        if (!params.data?.AUDIT_DATETIME) return null;
        // AUDIT_DATETIME is already in milliseconds (converted on server)
        // Return as Date object so ag-Grid recognizes it as a date column
        return new Date(params.data.AUDIT_DATETIME);
      },
      valueFormatter: (params) => {
        if (!params.value) return '';
        // Handle both Date objects and numbers
        const timestamp = params.value instanceof Date ? params.value.getTime() : params.value;
        return formatDateTime(timestamp);
      },
      filter: 'agDateColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        browserDatePicker: true,
        filterOptions: ['greaterThan', 'lessThan', 'inRange'],
      },
      sortable: false
    },
    {
      field: 'TIMESTAMP',
      headerName: 'Timestamp',
      width: 200,
      minWidth: 150,
      hide: true,
      sort: 'desc',
    },
    {
      field: 'USER_NAME',
      headerName: 'UserID',
      width: 200,
      minWidth: 150,
      filterParams: {
        filterOptions: ['contains', 'equals', 'notEqual'],
      },
    },
    {
      field: 'AUTH_ACTION',
      headerName: 'Action',
      width: 200,
      minWidth: 150,
      filterParams: {
        filterOptions: ['contains', 'equals', 'notEqual'],
      },
    },
    {
      field: 'REASON',
      headerName: 'Reason',
      width: 300,
      minWidth: 200,
      filterParams: {
        filterOptions: ['contains', 'equals', 'notEqual'],
      },
    },
  ];
}

export function getUserSessionColumns(): ColDef[] {
  return [
    {
      field: 'USER_NAME',
      headerName: 'UserID',
      width: 200,
      minWidth: 150,
    },
    {
      field: 'COUNTERPARTY_ID',
      headerName: 'Company Name',
      width: 350,
      minWidth: 250,
    },
    {
      field: 'START_TIMESTAMP',
      headerName: 'Session Start Time',
      width: 200,
      minWidth: 150,
      valueFormatter: (params) => (params.value ? formatDateTime(params.value) : ''),
      filter: 'agDateColumnFilter',
      filterParams: {
        buttons: ['apply', 'reset'],
        browserDatePicker: true,
        filterOptions: ['greaterThan', 'lessThan', 'inRange'],
      },
    },
  ];
}

